export default "__VITE_ASSET__Bv_ljJc9__"